import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button } from "../../components/ui/button";

const AuthButton = () => {
  const { loginWithRedirect, logout, isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) {
    return <Button disabled>Loading...</Button>;
  }

  if (isAuthenticated) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-sm text-muted-foreground">{user?.email || user?.name || "User"}</span>
        <Button
          onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
          variant="outline"
          size="sm"
        >
          Log Out
        </Button>
      </div>
    );
  }

  return (
    <Button onClick={() => loginWithRedirect()} variant="default" size="sm">
      Log In
    </Button>
  );
};

export default AuthButton;
